"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '&:hover': {
        color: theme.palette.denim[500]
      },
      '&:focus': {
        color: theme.palette.denim[500]
      },
      '&$active': {
        color: theme.palette.denim[500]
      },
      '&$active $icon': {
        color: "".concat(theme.palette.denim[500], " !important")
      }
    },
    active: {},
    icon: {
      opacity: 0.5
    }
  };
}, {
  name: 'pds-table-sort-label'
});

exports.default = _default;
